// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EEKap","textarea":"styles_textarea__heDLm"};